/* eslint-disable no-undef */
import R from 'ramda'
import { jsonParseWithMangoAtchar } from 'pages/widgets/mapping/common-functions'
import uuid from 'uuid'

const generateBlastId = () => uuid.v4()

const SEND_BLAST_ACTION_TYPE = 'SEND_BLAST'
const SEND_BLAST_DISPLAY_TYPE = 'Trigger blast'

const isSendBlastFormAction = R.propEq('type', SEND_BLAST_DISPLAY_TYPE)

const getQuickReply = R.pipe(
  R.prop('quickReply'),
  R.unless(
    R.isNil,
    R.applySpec({
      type: R.always('options'),
      options: R.pipe(R.identity, JSON.parse)
    })
  )
)

const getCtas = R.pipe(
  R.prop('ctas'),
  R.ifElse(
    R.either(R.isNil, R.isEmpty),
    R.always(undefined),
    jsonParseWithMangoAtchar
  )
)

const convertSendBlastFormActionToWidgetAction = R.applySpec({
  type: R.always(SEND_BLAST_ACTION_TYPE),
  attachmentUrl: R.prop('attachmentUrl'),
  cardUri: R.prop('cardUri'),
  media: R.prop('media'),
  message: R.prop('message'),
  quickReply: getQuickReply,
  ctas: getCtas,
  blastId: R.cond([
    [R.has('blastId'), R.prop('blastId')],
    [R.T, generateBlastId]
  ])
})

export { isSendBlastFormAction, convertSendBlastFormActionToWidgetAction }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/form-to-widget/send-blast.js